import React, { useEffect, useState } from 'react';
import './App.css';

const HRMNY_LOGO = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAwIiBoZWlnaHQ9IjgwIiB2aWV3Qm94PSIwIDAgMjAwIDgwIiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8ZGVmcz4KPGxpbmVhckdyYWRpZW50IGlkPSJsb2dvR3JhZGllbnQiIHgxPSI0MCIgeTE9IjEwIiB4Mj0iNDAiIHkyPSI2MCIgZ3JhZGllbnRVbml0cz0idXNlclNwYWNlT25Vc2UiPgo8c3RvcCBzdG9wLWNvbG9yPSIjNTNBNkRGIi8+CjxzdG9wIG9mZnNldD0iMSIgc3RvcC1jb2xvcj0iIzAwQjNBNCIvPgo8L2xpbmVhckdyYWRpZW50Pgo8L2RlZnM+CjxwYXRoIGQ9Ik00MCA2MEM1NS40NjQgNjAgNjggNDcuNDY0IDY4IDMyQzY4IDI2LjQ3NyA2Ni40NzcgMjEuMjQzIDYzLjY1NyAxNi45NDRMNDAGNDRMTDE2LjM0MyAxNi45NDRDMTM1MjcgMjEuMjQzIDEyIDI2LjQ3NyAxMiAzMkMxMiA0Ny40NjQgMjQuNTM2IDYwIDQwIDYwWiIgZmlsbD0idXJsKCNsb2dvR3JhZGllbnQpIi8+Cjx0ZXh0IHg9Ijg1IiB5PSI0NSIgZmlsbD0iIzAwQjNBNCIgZm9udC1mYW1pbHk9IkludGVyLCBzYW5zLXNlcmlmIiBmb250LXNpemU9IjI4IiBmb250LXdlaWdodD0iNzAwIiBsZXR0ZXItc3BhY2luZz0iMC4wNWVtIj5IUk1OWTwvdGV4dD4KPC9zdmc+";

const App = () => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [activeSection, setActiveSection] = useState('hero');

  useEffect(() => {
    setIsLoaded(true);
    
    // Smooth scroll behavior
    const handleScroll = () => {
      const sections = ['hero', 'problem', 'solution', 'audience', 'process', 'results', 'pilot'];
      const scrollPosition = window.scrollY + 100;
      
      sections.forEach(section => {
        const element = document.getElementById(section);
        if (element) {
          const offsetTop = element.offsetTop;
          const offsetHeight = element.offsetHeight;
          
          if (scrollPosition >= offsetTop && scrollPosition < offsetTop + offsetHeight) {
            setActiveSection(section);
          }
        }
      });
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
const calculateSavings = () => {
  const assessments = parseInt(document.getElementById('backlog').value, 10);
  const costPerAssessment = 323;
  const efficiencyRate = 0.15; // 15% savings
  const hoursPerAssessment = 12;
  const timeSavingRate = 0.4; // 40%

  if (isNaN(assessments) || assessments <= 0) {
    document.getElementById('calc-output').innerHTML = '⚠️ Please enter a valid number of assessments.';
    return;
  }

  const currentSpend = assessments * costPerAssessment;
  const savings = currentSpend * efficiencyRate;
  const hoursSaved = assessments * hoursPerAssessment * timeSavingRate;

  document.getElementById('calc-output').innerHTML = `
    <strong>Estimated Current Spend:</strong> £${currentSpend.toLocaleString()}<br>
    <strong>Estimated Savings (15%):</strong> £${savings.toLocaleString()}<br>
    <strong>Estimated Staff Hours Saved:</strong> ${hoursSaved.toLocaleString()} hours<br><br>
    <small class="text-gray-500">
      Based on £323 avg. assessment cost, 15% financial efficiency, 40% time savings.<br>
      Sources: SCIE, ADASS, NHS England.
    </small>
  `;
};



  return (
    <div className="App">
      {/* Navigation */}
      <nav className="fixed top-0 left-0 right-0 z-50 bg-white/80 backdrop-blur-xl border-b border-gray-100">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <div className="flex items-center">
              <a href="#hero" className="cursor-pointer">
            <img
  src="https://res.cloudinary.com/dl9rz5mqh/image/upload/v1751894474/hrmny_logo_d7p7on.png"
  alt="HRMNY"
  className="h-12"
/>

              </a>
            </div>
            <div className="hidden md:flex space-x-8">
              <a href="#problem" className="text-gray-600 hover:text-primary transition-colors">Problem</a>
              <a href="#solution" className="text-gray-600 hover:text-primary transition-colors">Solution</a>
              <a href="#process" className="text-gray-600 hover:text-primary transition-colors">How It Works</a>
              <a href="#outcomes" className="text-gray-600 hover:text-primary transition-colors">Outcomes</a>
            </div>
            <div className="flex space-x-4">
            
              <button className="btn-primary">Join Pilot</button>
            </div>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <section id="hero" className="hero-section">
        <div className="hero-background">
          <img 
            src="https://i.imgur.com/nb7MqaN.png"
            alt="Technology and data flow visualization"
            className="hero-image"
          />
          <div className="hero-overlay"></div>
        </div>
        
        <div className="hero-content">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-32">
            <div className="max-w-4xl">
              <h1 className={`hero-headline ${isLoaded ? 'animate-fade-in' : ''}`}>
                Because every assessment is a person's life. Not paperwork.
              </h1>
              <p className={`hero-subheadline ${isLoaded ? 'animate-fade-in-delay' : ''}`}>
                HRMNY helps local authorities, assessors, and NHS teams complete liberty and mental capacity assessments faster, with total clarity and compliance.
              </p>
              <div className={`hero-cta ${isLoaded ? 'animate-fade-in-delay-2' : ''}`}>
    <a href="#process" className="btn-primary-large mr-4">
  See How It Works
</a>

                <button className="btn-secondary-large">Join the Pilot</button>
              </div>
            </div>
          </div>
        </div>
        
        {/* Scroll indicator */}
        <div className="scroll-indicator">
          <div className="scroll-mouse"></div>
        </div>
      </section>

      {/* Problem Section */}
      <section id="problem" className="section-padding bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="section-headline-accent">Why the Current System Fails</h2>
          </div>
          
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div>
              <div className="stat-card glass-card">
                <div className="stat-number">332,000</div>
                <div className="stat-label">Deprivation of Liberty cases submitted in the UK last year</div>
              </div>
              <div className="stat-card glass-card mt-6">
                <div className="stat-number">1 in 5</div>
                <div className="stat-label">Completed on time</div>
              </div>
            </div>
            
            <div className="space-y-6">
              <p className="text-xl text-gray-700 leading-relaxed">
                
             
                 The system is overwhelmed, with paper-based admin, outdated tools, and fragmented communication.
                 HRMNY was built to change that, using empathetic technology that centres people, 
                not just processes , helping professionals work faster, fairer, and with more humanity.
              </p>
              
              <div className="problem-list">
                <div className="problem-item">
                  <div className="problem-icon">📄</div>
                  <div>Paper-based administration causing delays</div>
                </div>
                <div className="problem-item">
                  <div className="problem-icon">🔧</div>
                  <div>Outdated tools hampering efficiency</div>
                </div>
                <div className="problem-item">
                  <div className="problem-icon">💬</div>
                  <div>Fragmented communication between teams</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Solution Section */}
      <section id="solution" className="section-padding">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="section-headline-accent">What HRMNY Does Differently</h2>
            <p className="section-subheadline">We replaced chaos with clarity.</p>
          </div>

          <div className="solution-grid">
            <div className="solution-card">
              <div className="solution-before">
                <h4>Manual case allocation</h4>
                <img src="https://images.pexels.com/photos/416405/pexels-photo-416405.jpeg" alt="Manual paperwork and case management" className="solution-image" />
              </div>
              <div className="solution-arrow">→</div>
              <div className="solution-after">
                <h4>SmartMatch™ automated pairing</h4>
                <img src="https://images.unsplash.com/photo-1664526937033-fe2c11f1be25" alt="Automated allocation network" className="solution-image" />
              </div>
            </div>

            <div className="solution-card">
              <div className="solution-before">
                <h4>Email + Excel tracking</h4>
                <img src="https://images.pexels.com/photos/590022/pexels-photo-590022.jpeg" alt="Excel spreadsheet tracking" className="solution-image" />
              </div>
              <div className="solution-arrow">→</div>
              <div className="solution-after">
                <h4>Live dashboard & timeline</h4>
                <img src="https://images.unsplash.com/photo-1551288049-bebda4e38f71" alt="Digital dashboard interface" className="solution-image" />
              </div>
            </div>

            <div className="solution-card">
              <div className="solution-before">
                <h4>Scattered forms</h4>
                <img src="https://images.unsplash.com/photo-1560122585-6259c8423491" alt="Scattered paperwork" className="solution-image" />
              </div>
              <div className="solution-arrow">→</div>
              <div className="solution-after">
                <h4>Auto-filled, AI-supported templates</h4>
                <img src="https://images.pexels.com/photos/7247404/pexels-photo-7247404.jpeg" alt="Digital forms processing" className="solution-image" />
              </div>
            </div>

            <div className="solution-card">
              <div className="solution-before">
                <h4>Delayed invoices</h4>
                <img src="https://images.pexels.com/photos/7888676/pexels-photo-7888676.jpeg" alt="Manual invoice paperwork" className="solution-image" />
              </div>
              <div className="solution-arrow">→</div>
              <div className="solution-after">
                <h4>Real-time approvals + Stripe/GoCardless</h4>
                <img src="https://images.unsplash.com/photo-1683313107043-283d0319a11e" alt="Digital payment processing" className="solution-image" />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Audience Section */}
      <section id="audience" className="section-padding bg-gradient-to-br from-primary/5 to-secondary/5">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="section-headline-accent">Who It's For</h2>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="audience-card">
              <h3 className="audience-title">Local Authorities</h3>
              <p className="audience-description">Real-time compliance view & workload insights</p>
              <ul className="audience-benefits">
                <li>Dashboard oversight</li>
                <li>Compliance tracking</li>
                <li>Resource allocation</li>
              </ul>
            </div>

            <div className="audience-card">
              <h3 className="audience-title">Assessors</h3>
              <p className="audience-description">Manage bookings, complete forms, and get paid on time</p>
              <ul className="audience-benefits">
                <li>Streamlined workflows</li>
                <li>Digital forms</li>
                <li>Automated payments</li>
              </ul>
            </div>

            <div className="audience-card">
              <h3 className="audience-title">NHS + Providers</h3>
              <p className="audience-description">Easier referrals, oversight, and workflow integration</p>
              <ul className="audience-benefits">
                <li>Seamless referrals</li>
                <li>Workflow integration</li>
                <li>Progress tracking</li>
              </ul>
            </div>

            <div className="audience-card coming-soon">
              <h3 className="audience-title">Families</h3>
              <p className="audience-description">Coming soon: family-facing view and status updates</p>
              <div className="coming-soon-badge">Coming Soon</div>
            </div>
          </div>
        </div>
      </section>

      {/* Process Section */}
      <section id="process" className="section-padding">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="section-headline-accent">How It Works</h2>
          </div>

          <div className="process-flow">
            <div className="process-step">
              <div className="process-number">1</div>
              <div className="process-content">
                <h3>Referral Made</h3>
                <p>A referral is made (postcode or form upload)</p>
              </div>
            </div>

            <div className="process-connector"></div>

            <div className="process-step">
              <div className="process-number">2</div>
              <div className="process-content">
                <h3>Smart Allocation</h3>
                <p>HRMNY allocates the right professional (e.g., BIA, s12 doctor)</p>
              </div>
            </div>

            <div className="process-connector"></div>

            <div className="process-step">
              <div className="process-number">3</div>
              <div className="process-content">
                <h3>Assessment Completion</h3>
                <p>Assessors complete Forms 1–12 on-platform</p>
              </div>
            </div>

            <div className="process-connector"></div>

            <div className="process-step">
              <div className="process-number">4</div>
              <div className="process-content">
                <h3>AI Quality Assurance</h3>
                <p>AI supports quality assurance</p>
              </div>
            </div>

            <div className="process-connector"></div>

            <div className="process-step">
              <div className="process-number">5</div>
              <div className="process-content">
                <h3>Real-time Tracking</h3>
                <p>Stakeholders track progress and approve in real time</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Results Section */}
      <section id="outcomes" className="section-padding bg-secondary text-white relative overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-br from-white/80 to-white/60"></div>
        <img 
          src="https://images.unsplash.com/photo-1586448646505-e7bcafcd83a1" 
          alt="Healthcare analytics"
          className="absolute inset-0 w-full h-full object-cover opacity-10"
        />
        
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="section-headline-accent text-secondary">Outcomes & Projected Savings</h2>
            <p className="section-subheadline text-secondary">What HRMNY has shown so far and where it can go:</p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="results-card">
              <div className="results-number">30%</div>
              <div className="results-label">admin time saved in pilot councils</div>
            </div>

            <div className="results-card">
              <div className="results-number">80%</div>
              <div className="results-label">faster turnaround from referral to approval</div>
            </div>

            <div className="results-card">
              <div className="results-number">95%</div>
              <div className="results-label">audit-ready compliance (vs 19% national average)</div>
            </div>

            <div className="results-card">
              <div className="results-number">£158M</div>
              <div className="results-label">national backlog cost reduction potential</div>
            </div>
          </div>

          <div className="mt-16 text-center">
            <div className="inline-block bg-white/10 backdrop-blur-sm rounded-2xl p-8">
              <div class="text-4xl font-bold text-primary mb-2">£583.8M</div>
              <div className="text-lg text-white-300">Estimated annual savings if deployed across 1.8M assessments</div>
            </div>
      {/* Footnote starts here */}
  <div className="mt-2">
    <p className="text-sm text-white/70 italic">
      *Figures based on national estimates from financial year 2022/23
    </p>
          </div>
        </div>
      </div> {/* THIS IS THE CRUCIAL MISSING CLOSING DIV */}
      </section>

<section id="calculator" className="max-w-3xl mx-auto mt-20 bg-white/90 shadow-xl rounded-2xl p-10 text-gray-900">
  <h2 className="text-3xl font-bold text-primary mb-3">Return on Investment Calculator</h2>
  <p className="mb-6 text-base text-gray-600">Enter your assessment volume to estimate time and cost savings with HRMNY.</p>

  <div className="mb-6">
    <label className="block mb-2 font-semibold">🔢 Number of Assessments</label>
    <input
      type="number"
      id="backlog"
      placeholder="e.g. 1000"
      className="w-full p-3 border border-gray-300 rounded-md"
    />
  </div>

  <button
    onClick={calculateSavings}
    className="bg-blue-600 hover:bg-blue-700 text-white font-medium py-2 px-6 rounded-md transition duration-200"
  >
    Calculate
  </button>

  <div id="calc-output" className="mt-8 text-base space-y-2 text-gray-800"></div>
</section>




      {/* Pilot Section */}
      <section id="pilot" className="section-padding bg-gradient-to-br from-primary/10 to-highlights/10">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="section-headline-accent">Join the Pilot</h2>
          <p className="text-xl text-gray-700 mb-12 leading-relaxed">
            We're partnering with select local authorities and care providers to pilot HRMNY in real-world settings.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center mb-12">
            <button className="btn-primary-large">Request Demo</button>
            <button className="btn-secondary-large">Download Brochure</button>
            <button className="btn-outline-large">See Pilot Timeline</button>
          </div>

          <div className="pilot-features grid md:grid-cols-3 gap-8 mt-16">
            <div className="pilot-feature">
              <div className="pilot-feature-icon-brand">
                <svg className="w-12 h-12" fill="#F66A0A" viewBox="0 0 24 24">
                  <path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z"/>
                </svg>
              </div>
              <h3>Fast Implementation</h3>
              <p>Get up and running in weeks, not months</p>
            </div>
            <div className="pilot-feature">
              <div className="pilot-feature-icon-brand">
                <svg className="w-12 h-12" fill="#F66A0A" viewBox="0 0 24 24">
                  <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
                </svg>
              </div>
              <h3>Dedicated Support</h3>
              <p>Full onboarding and training support</p>
            </div>
            <div className="pilot-feature">
              <div className="pilot-feature-icon-brand">
                <svg className="w-12 h-12" fill="#F66A0A" viewBox="0 0 24 24">
                  <path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM9 17H7v-7h2v7zm4 0h-2V7h2v10zm4 0h-2v-4h2v4z"/>
                </svg>
              </div>
              <h3>Real Results</h3>
              <p>Measurable improvements from day one</p>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-secondary text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
          <div className="grid md:grid-cols-4 gap-8">
            <div className="md:col-span-2">
              <img
  src="https://res.cloudinary.com/dl9rz5mqh/image/upload/v1751894474/hrmny_logo_d7p7on.png"
  alt="HRMNY"
  className="h-12 mb-6"
/>

              <p className="text-gray-400 mb-6 max-w-md">
                Transforming how liberty and mental capacity assessments are managed with clarity, compliance, and care.
              </p>
              <div className="contact-info">
                <p className="text-gray-400 mb-2">hello@hrmny.co.uk</p>
                <p className="text-gray-400">+44 020 1234 5678</p>
              </div>
            </div>

            <div>
              <h4 className="font-semibold mb-4">Platform</h4>
              <ul className="space-y-2 text-gray-400">
                <li><a href="#" className="hover:text-white transition-colors">Features</a></li>
                <li><a href="#" className="hover:text-white transition-colors">Pricing</a></li>
                <li><a href="#" className="hover:text-white transition-colors">Security</a></li>
                <li><a href="#" className="hover:text-white transition-colors">Integrations</a></li>
              </ul>
            </div>

            <div>
              <h4 className="font-semibold mb-4">Legal</h4>
              <ul className="space-y-2 text-gray-400">
                <li><a href="#" className="hover:text-white transition-colors">Privacy</a></li>
                <li><a href="#" className="hover:text-white transition-colors">Terms</a></li>
                <li><a href="#" className="hover:text-white transition-colors">Accessibility</a></li>
                <li><a href="#" className="hover:text-white transition-colors">Compliance</a></li>
              </ul>
            </div>
          </div>

          <div className="border-t border-gray-800 mt-12 pt-8 flex flex-col sm:flex-row justify-between items-center">
            <p className="text-gray-400 text-sm">© 2025 HRMNY. All rights reserved.</p>
            <div className="flex space-x-4 mt-4 sm:mt-0">
              <a href="#" className="text-gray-400 hover:text-white transition-colors">
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M19 3a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14m-.5 15.5v-5.3a3.26 3.26 0 0 0-3.26-3.26c-.85 0-1.84.52-2.32 1.3v-1.11h-2.79v8.37h2.79v-4.93c0-.77.62-1.4 1.39-1.4a1.4 1.4 0 0 1 1.4 1.4v4.93h2.79M6.88 8.56a1.68 1.68 0 0 0 1.68-1.68c0-.93-.75-1.69-1.68-1.69a1.69 1.69 0 0 0-1.69 1.69c0 .93.76 1.68 1.69 1.68m1.39 9.94v-8.37H5.5v8.37h2.77z"/>
                </svg>
              </a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default App;